import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const SuccessNotificationContainer = ()=>{
    const intl = useIntl();
    const labels = React.useMemo(()=>({
            successNotification: intl.getLabel('cart.success.notification')
        })
    , [
        intl
    ]);
    return /*#__PURE__*/ React.createElement(Alert, {
        icon: "checkmark",
        type: "success",
        message: labels.successNotification
    });
};

export { SuccessNotificationContainer };
//# sourceMappingURL=SuccessNotificationContainer.js.map
